import { recibosCobroAPI, pagosAPI } from '../services/api';

export async function cargarFormasRecibo(comprobante) {
  if (!comprobante) return [];
  try {
    if (comprobante.recibo_cobro_id) {
      const res = await recibosCobroAPI.getById(comprobante.recibo_cobro_id);
      if (res.success && res.data?.formas_pago) return res.data.formas_pago;
    }
    if (comprobante.movimiento_id) {
      const res = await recibosCobroAPI.getByMovimientoId(comprobante.movimiento_id);
      if (res.success && res.data?.formas_pago) return res.data.formas_pago;
    }
  } catch (_) {
    /* sin formas */
  }
  return [];
}

export async function cargarFormasPago(comprobante) {
  if (!comprobante) return [];
  try {
    if (comprobante.movimiento_id) {
      const res = await pagosAPI.getByMovimientoId(comprobante.movimiento_id);
      if (res.success && res.data?.formas_pago) return res.data.formas_pago;
    }
  } catch (_) {
    /* sin formas */
  }
  return [];
}
